import { userModel } from 'entities/user';
import {
  ContractsNames,
  ContractsService,
  error,
  getToastMessage,
  notifyText,
  request,
  success,
  toDecimals,
} from 'shared';
import { call, put, select, takeLatest } from 'typed-redux-saga';

import { userActions } from '../reducer';

import { approveSaga } from './approve';
import { getVestingSwapInfoSaga } from './getSwapInfo';

export function* swapSaga({ type, payload }: ReturnType<typeof userActions.swap>) {
  yield put(request(type));
  const { web3Provider, amount, decimals, lockType } = payload;

  const amountWithDecimals = toDecimals(amount, decimals as string);
  const { address: userWalletAddress, network, chainType } = yield* select(userModel.selectors.selectUserWeb3Info);

  const contractsService = new ContractsService(web3Provider);

  const { address: swapAddress } = ContractsService.getContractData(
    ContractsNames.StarsVestingSwap,
    network,
    chainType,
  );
  const { address: tokenAddress } = ContractsService.getContractData(ContractsNames.StarsV1, network, chainType);

  try {
    const vestingSwapContract = contractsService.getStarsVestingSwapContract(swapAddress);

    yield call(approveSaga, {
      type: userActions.approve.type,
      payload: {
        amount,
        spenderAddress: swapAddress,
        tokenAddress,
        web3Provider,
      },
    });

    yield* call(vestingSwapContract.methods.deposit(lockType, amountWithDecimals).send, {
      from: userWalletAddress,
    });

    yield call(getVestingSwapInfoSaga, {
      type: userActions.getVestingSwapInfo.type,
      payload: { web3Provider },
    });

    getToastMessage('success', notifyText.swap.success);
    yield put(success(type));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    getToastMessage('error', notifyText.swap.error);
    yield put(error(type));
  }
}

export default function* listener() {
  yield takeLatest(userActions.swap.type, swapSaga);
}
